import { ImageScale } from '@front-app/services/ImageApi/ImageModel';
import { singleton } from '@front-app/util/interface';
import { getImageFetchers } from '@front-app/workers/ImageWorkerWrapper';
import { getGroupsStore } from '../modules/groups';
import { createV1ImageStore, createV2ImageStore } from '../modules/image';

export const GroupsStore = singleton(getGroupsStore);
export const GroupsLogoStore = createV2ImageStore(() => getImageFetchers().getGroupLogo, ImageScale.LARGE_2X);
export const GroupsBannerStore = createV2ImageStore(() => getImageFetchers().getGroupBanner, ImageScale.BANNER);
export const GroupsBannerStoreV1 = createV1ImageStore();
